import { cn } from '@/lib/cn'
import { type InputHTMLAttributes, forwardRef } from 'react'

export type InputProps = InputHTMLAttributes<HTMLInputElement>

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'flex min-h-[44px] w-full rounded-xl border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
      'aria-[invalid=true]:border-rose-300 aria-[invalid=true]:focus-visible:ring-rose-400 dark:aria-[invalid=true]:border-rose-800',
      className,
    )}
    {...props}
  />
))
Input.displayName = 'Input'
